<template>
  <div class="sample-expression mt-n4"
       :id="sample_expression_id">
    <svg></svg>
  </div>
</template>

<script>
import * as d3 from 'd3';
import tippy, { followCursor } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
export default {
  name: 'SampleExpression',
  data() {
    return {
      sampleIDs: [],
      sampleExpressions: [],
      sample_expression_id: null,
      p_value: null,
      r_value: null,
    }
  },
  props: {
    sampleId: {
      type: Array,
      default() {
        return []
      }
    },
    sampleExpression: {
      type: Array,
      default() {
        return []
      }
    },
    pValue: {
      type: Number,
      default() {
        return 0
      }
    },
    rValue: {
      type: Number,
      default() {
        return 0
      }
    },
  },
  // 此处必须初始化 sampleId 为 [], 不然当添加突变基因时，watch 不到 sampleID 的变化
  // mounted() {
  //   this.sampleId = [];
  //   this.pValue = 0;
  // },
  watch: {
    sampleId(val) {
      if (val.length > 0) {
        // console.log(val);
        this.sampleIDs = val;
      }
    },
    sampleExpression(val) {
      // console.log(val);
      this.sampleExpressions = val;
      this.sample_expression_id = val && val[0].gene_name;
      setTimeout(() => {
        // console.log(this.r_value);
        this.initSampleExpressionPlot();
      }, 500);
    },
    pValue(val) {
      // console.log(val);
      if (val && val == "NA") {
        this.p_value = 1;
      } else {
        this.p_value = val;
      }
    },
    rValue(val) {
      // console.log(val);
      if (val && val == "NA") {
        this.r_value = 0;
      } else {
        this.r_value = val;
      }
    },
  },
  methods: {
    initSampleExpressionPlot() {
      // all samples which have PSI
      let samples = this.sampleIDs;
      let sample_size = samples.length;

      let sampleExpressions = this.sampleExpressions;

      let exp = sampleExpressions[0].sample_exp;
      // console.log(exp);
      // get the retained sampleIDs which have expression
      let samplesID_in_exp = [];
      if (sampleExpressions) {
        // console.log(sampleCNVs[0].sample_cnv[0]);
        exp.forEach((v, i, a) => {
          samplesID_in_exp.push(v.sample_id)
        })
      }
      // console.log(samplesID_in_exp);

      let all_samples_exp = [];
      // get the sampleIDs which don't have expression
      samples.forEach((v, i, a) => {
        if (!samplesID_in_exp.includes(v)) {
          let sample = {};
          sample.sample_id = v;
          all_samples_exp.push(sample);
        }
      });
      all_samples_exp = [...all_samples_exp, ...exp]
      //   console.log(all_samples_exp);

      // 获取div屏幕宽度
      // console.log(document.getElementById("splice-expression-heatmap").clientWidth);
      let clientWidth = document.getElementById("splice-expression-heatmap").clientWidth;

      const margin = ({ top: 0, left: 200, right: 30, bottom: 0, });
      // const width = sample_size * 8 + margin.left + margin.right;
      const width = clientWidth;
      const height = 40;
      // const gridWidth = 6;
      const gridWidth = (clientWidth - margin.left - margin.right) / sample_size;
      // console.log(gridWidth);
      const gridHeight = 20;
      const sampleColor = "#BDBDBD";

      // Here, must replace this.sample_expression_id as gene_name !!!
      let gene_name = this.sample_expression_id;
      // let pvalue = this.p_value && this.p_value.toFixed(3);
      let pvalue;
      if (this.p_value > 0) {
        pvalue = this.p_value && this.p_value.toFixed(3);
      } else {
        pvalue = '0.000';
      }
      let rvalue;
      if (Math.abs(this.r_value) > 0) {
        rvalue = this.r_value && this.r_value.toFixed(3);
      } else {
        rvalue = '0.000';
      }

      let bandName = gene_name + ' | ' + rvalue + ' | ' + pvalue;

      const svg = d3.selectAll("div.sample-expression")
        .filter(function () { return d3.select(this).attr('id') == gene_name })
        .select('svg')
      // .attr("viewBox", [0, 0, width, height]);
      svg.attr("width", width);
      svg.attr("height", height);

      let myColor = d3
        .scaleSequential()
        .domain([-10, 10])
        .interpolator(t => d3.interpolateRdBu(1 - t))

      // Add xAxis
      let xScale = d3.scaleBand()
        .domain(samples)
        .range([margin.left, width - margin.right])
        .padding(1);

      // Add yAxis
      let yScale = d3.scaleBand()
        .domain([bandName])
        .range([margin.top, height])
      let yAxis = d3.axisLeft(yScale)
      svg.append("g")
        .attr("class", "y-axis")
        .attr("transform", `translate(${margin.left},${gridHeight / 2 - 8})`)
        .call(yAxis)
        .call(g => g.select(".domain").remove())
        .call(g => g.selectAll('.tick line').remove())
        .call(g => g.selectAll('.tick text').attr("font-size", "13")
          .attr("font-family", "Arial").attr("font-weight", "bold"));
      let yaxisText = d3.selectAll("div.sample-expression")
        .filter(function () { return d3.select(this).attr('id') == gene_name })
        .select('g.y-axis');
      yaxisText.attr('data-tippy-content', (d, i) => {
        return `<div>Gene Name | Pearson Correlation Coefficient (R Value) | Pearson P Value</div>`
      });
      tippy(yaxisText.nodes(), {
        allowHTML: true,
        placement: 'bottom',
        interactive: true,
        interactiveDebounce: 0,
        appendTo: () => document.body,
        maxWidth: 300,
        delay: 0,
        duration: [0, 0],
      });

      // Add Samples rect
      svg.append('g')
        .attr("class", "samples-all")
        .selectAll()
        .data(all_samples_exp)
        .join("rect")
        .attr('x', d => xScale(d.sample_id))
        .attr('y', yScale(bandName) + gridHeight / 2)
        .attr('width', gridWidth)
        .attr('height', gridHeight)
        // .attr('rx', 0.5) // set border-radius
        .attr('stroke-width', 0.5) // set border-width
        .attr('fill', function (d) {
          if (d.exp) {
            return myColor(d.exp)
          } else {
            return sampleColor
          }
        });
      let sample_rects = d3.selectAll("div.sample-expression")
        .filter(function () { return d3.select(this).attr('id') == gene_name })
        .selectAll('.samples-all rect');
      //   console.log(sample_rects);
      sample_rects.attr('data-tippy-content', (d, i) => {
        return `<div>Sample ID: ${d.sample_id}</div>
        <div>Expression: ${d.exp || "NA"}</div>`
      });
      tippy(sample_rects.nodes(), {
        allowHTML: true,
        placement: 'left',
        interactive: true,
        interactiveDebounce: 0,
        appendTo: () => document.body,
        // followCursor: 'horizontal',
        // plugins: [followCursor],
        maxWidth: 300,
        delay: 0,
        duration: [0, 0],
      });

      // Add legend colorBar
      //   const legendHeight = height / 2;
      //   svg.append('rect')
      //     .attr('width', 10)
      //     .attr('height', legendHeight)
      //     .attr(
      //       'transform',
      //       `translate(${width - margin.right + 10}, ${legendHeight - 2})`
      //     )
      //     .style('fill', 'url(#linear-gradient)');
      //   // Add Legend title
      //   svg.append('text')
      //     .text('Expression Value')
      //     .attr(
      //       'transform',
      //       `translate(${width - margin.right + 16}, ${margin.top})`
      //     )
      //     .attr('text-anchor', 'middle')
      //     .attr('font-size', 6)
      //     .attr('font-weight', 'bold');
      //   // Add Legend min value
      //   svg.append('text')
      //     .text('-10.0')
      //     .attr(
      //       'transform',
      //       `translate(${width - margin.right + 22}, ${margin.top + 5})`
      //     )
      //     .attr('font-size', 5)
      //   // Add Legend max value
      //   svg.append('text')
      //     .text('10.0')
      //     .attr(
      //       'transform',
      //       `translate(${width - margin.right + 22}, ${margin.top + 4 + legendHeight})`
      //     )
      //     .attr('font-size', 5)
    }
  }
}
</script>
<style scoped>
</style>